export const tosVersion = 9
export const coverageMessageARHomeGroup = ['MS0000', 'MSH000', 'MST000']

export const groupIds = {
	jbHunt: [
		'020410',
		'020411',
		'020413',
		'020415',
		'020416',
		'020417',
		'020418',
		'020419',
		'020420',
		'020421',
		'020422',
		'020423',
		'020424',
		'020425',
		'020426',
		'020427',
		'S20410',
		'S20411',
		'S20413',
		'S20415',
		'S20416',
		'S20417',
		'S20418',
		'S20419',
		'S20420',
		'S20421',
		'S20422',
		'S20423',
		'S20424',
		'S20425',
		'S20426',
		'S20427',
		'S20428',
		'S20429',
		'S20430'
	],
	// WM Included health
	walmartIh: [
		'080410',
		'080411',
		'080412',
		'080413',
		'080414',
		'080415',
		'080218',
		'080221',
		'080224',
		'080226',
		'080227',
		'080416',
		'080417',
		'080228',
		'080231',
		'080234',
		'080236',
		'080237',
		'080419',
		'080420',
		'080258',
		'080261',
		'080264',
		'080266',
		'080267',
		'080422',
		'080423',
		'080268',
		'080271',
		'080274',
		'080276',
		'080277',
		'080425',
		'080426',
		'080278',
		'080281',
		'080284',
		'080286',
		'080287',
		'080428',
		'080429',
		'080288',
		'080291',
		'080294',
		'080296',
		'080297',
		'080431',
		'080432',
		'080310',
		'080311',
		'080314',
		'080315',
		'080434',
		'080435',
		'080436',
		'080437',
		'080438',
		'080439',
		'080440',
		'080441',
		'080476',
		'080477',
		'080478',
		'080479',
		'080480',
		'080481',
		'080482',
		'080483',
		'080484',
		'080485',
		'080322',
		'080323',
		'080326',
		'080327',
		'080442',
		'080443',
		'080444',
		'080445',
		'080446',
		'080447',
		'080448',
		'080449',
		'080486',
		'080487',
		'080488',
		'080489',
		'080490',
		'080491',
		'080492',
		'080493',
		'080494',
		'080495',
		'080328',
		'080329',
		'080332',
		'080333',
		'080450',
		'080451',
		'080452',
		'080453',
		'080454',
		'080455',
		'080456',
		'080457',
		'080496',
		'080497',
		'080498',
		'080499',
		'080512',
		'080513',
		'080514',
		'080515',
		'080516',
		'080517',
		'080458',
		'080459',
		'080464',
		'080465',
		'080470',
		'080471',
		'080460',
		'080461',
		'080466',
		'080467',
		'080472',
		'080473',
		'080462',
		'080463',
		'080468',
		'080469',
		'080474',
		'080475',
		'0S0001',
		'0S0002',
		'0S0003',
		'0S0004',
		'0S0005',
		'0S0006',
		'0S0011',
		'0S0012',
		'0S0013',
		'0S0014',
		'0S0015',
		'0S0016',
		'0S0111',
		'0S0113',
		'0S0115',
		'0S0117',
		'0S0119',
		'0S0121',
		'0S0123',
		'0S0125',
		'0S0127',
		'0S0112',
		'0S0114',
		'0S0116',
		'0S0118',
		'0S0120',
		'0S0122',
		'0S0124',
		'0S0126',
		'0S0128',
		'0S0131',
		'0S0133',
		'0S0135',
		'0S0137',
		'0S0139',
		'0S0141',
		'0S0143',
		'0S0145',
		'0S0147',
		'0S0132',
		'0S0134',
		'0S0136',
		'0S0138',
		'0S0140',
		'0S0142',
		'0S0144',
		'0S0146',
		'0S0148',
		'0S0151',
		'0S0153',
		'0S0155',
		'0S0157',
		'0S0159',
		'0S0161',
		'0S0163',
		'0S0165',
		'0S0167',
		'0S0152',
		'0S0154',
		'0S0156',
		'0S0158',
		'0S0160',
		'0S0162',
		'0S0164',
		'0S0166',
		'0S0168',
		'0S0021',
		'0S0022',
		'0S0023',
		'0S0024',
		'0S0025',
		'0S0026',
		'0S0031',
		'0S0032',
		'0S0033',
		'0S0034',
		'0S0035',
		'0S0036',
		'0S0027',
		'0S0028',
		'0S0181',
		'0S0182'
	],
	complete: ['840000', '850000'],
	skai: [
		'010606',
		'010506',
		'010507',
		'010607',
		'010505',
		'010605',
		'010509',
		'010609',
		'010994',
		'010993',
		'080410',
		'080411',
		'080412',
		'080413',
		'080414',
		'080415',
		'080218',
		'080221',
		'080224',
		'080226',
		'080227',
		'080416',
		'080417',
		'080228',
		'080231',
		'080234',
		'080236',
		'080237',
		'080419',
		'080420',
		'080258',
		'080261',
		'080264',
		'080266',
		'080267',
		'080422',
		'080423',
		'080268',
		'080271',
		'080274',
		'080276',
		'080277',
		'080425',
		'080426',
		'080278',
		'080281',
		'080284',
		'080286',
		'080287',
		'080428',
		'080429',
		'080288',
		'080291',
		'080294',
		'080296',
		'080297',
		'080431',
		'080432',
		'080458',
		'080459',
		'080464',
		'080465',
		'080470',
		'080471',
		'080460',
		'080461',
		'080466',
		'080467',
		'080472',
		'080473',
		'080462',
		'080463',
		'080468',
		'080469',
		'080474',
		'080475',
		'020424',
		'020423',
		'020410',
		'020411',
		'020413',
		'020415',
		'020416',
		'020425',
		'020426',
		'020427',
		'020420',
		'020421',
		'020422',
		'020419',
		'020417',
		'020418',
		'020650',
		'020651',
		'020653',
		'020652',
		'022019',
		'022018',
		'022027',
		'022029',
		'022025',
		'022023',
		'022021',
		'022026',
		'022028',
		'022024',
		'022022',
		'022020',
		'070954',
		'070920',
		'070922',
		'070921',
		'070926',
		'070160',
		'070150',
		'070930',
		'070944',
		'070129',
		'070939',
		'070134',
		'070957',
		'070958',
		'070959',
		'070934',
		'070937',
		'070945',
		'070940',
		'070133',
		'070128',
		'070137',
		'070149',
		'070136',
		'070118',
		'070112',
		'070151',
		'070161',
		'070135',
		'070123',
		'070111',
		'070956',
		'070955'
	],
	arHome: ['MS0000', 'MSH000', 'MST000'],
	paychex: ['00S001', '00S002', '00S003', '00S004', '00S005', '00S006'],
	includedHealth: ['0S0027', '0S0028', '0S0181', '0S0182'],
	primeHfa: ['S20850', 'S20851']
}

export const VUETIFY_ALERT_TYPES = new Set(['warning', 'info', 'error', 'success'])

type CarrierCodeKeys = 'walmart'
type CarrierCodes = Record<CarrierCodeKeys, string[]>

export const carrierCodes: CarrierCodes = {
	walmart: ['KS', 'MO', 'OK', 'RZ', 'TP', 'WS']
}

export const checkCarrierCode = (code: string, key: CarrierCodeKeys): boolean => {
	return carrierCodes[key]?.includes(code)
}
